import { FC, useEffect, memo } from 'react';
import WebFont from 'webfontloader';
import { useConfig } from '../../hooks/config';
import Family from './Family';

interface iFamily {
  name: string;
  family: string;
}

interface iFontFamiliesProps {
  families: iFamily[];
  value: string;
  onChange: (value: string) => void;
}

const FontFamilies: FC<iFontFamiliesProps> = memo(({ families, value, onChange }) => {
  const config = useConfig();
  useEffect(() => {
    if (families?.length > 0) {
      const fonts = families?.map?.((family) => family.name) ?? [];

      if (fonts.length > 0) {
        WebFont.load({
          custom: { families: fonts },
        });
      }
    }
  }, [JSON.stringify(families)]);

  const fontfamily = value ?? config.options.families?.[0]?.name;

  return (
    <div className='font-families'>
      {families?.map?.((family) => (
        <Family
          {...family}
          key={family.family}
          onSelect={onChange}
          active={fontfamily === family.family || fontfamily === family.name}
        />
      ))}
    </div>
  );
});

export default FontFamilies;
